const HELP_TEXTS = {
  actionButtons: {
    cloneContactList: 'Clone this contact list',
    exportContactsWithSegmentations:
      'A detailed export of this contact list including exhaustive segmentations will be sent by Email to you. It can take a few minutes for the Email to be sent.',
  },
  labels: {
    contactFilters:
      'The filters below use information related to Opportunities and Campaigns where the Contact is set as Quote Primary or Secondary Contact',
  },
};

export default HELP_TEXTS;
